import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const AddSlabModal = ({ open, onClose, onSave, initialData }) => {
  const [width, setWidth] = useState("");
  const [length, setLength] = useState("");
  const [quantity, setQuantity] = useState("");
  const [notes, setNotes] = useState("");

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // 🔄 Töltse be az initialData-t szerkesztéshez
  useEffect(() => {
    if (initialData) {
      setWidth(initialData.width || "");
      setLength(initialData.length || "");
      setQuantity(initialData.quantity || "");
      setNotes(initialData.notes || "");
    } else {
      setWidth("");
      setLength("");
      setQuantity("");
      setNotes("");
    }
  }, [initialData, open]);

  const handleSubmit = () => {
    if (!width || !length || !quantity) {
      alert("Lățime, lungime și cantitate sunt obligatorii.");
      return;
    }

    onSave({
      width: parseFloat(width),
      length: parseFloat(length),
      quantity: parseInt(quantity),
      notes: notes.trim(),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          padding: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "1.5rem",
        }}
      >
        {initialData ? "✏️ Editează lastra" : "➕ Adaugă lastră nouă"}
      </DialogTitle>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <TextField
          label="Lățime (cm)"
          type="number"
          value={width}
          onChange={(e) => setWidth(e.target.value)}
          fullWidth
          sx={{ mt: 1.5 }}
          InputProps={{ sx: { borderRadius: 2 } }}
        />

        <TextField
          label="Lungime (cm)"
          type="number"
          value={length}
          onChange={(e) => setLength(e.target.value)}
          fullWidth
          InputProps={{ sx: { borderRadius: 2 } }}
        />
        <TextField
          label="Cantitate"
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          fullWidth
          InputProps={{ sx: { borderRadius: 2 } }}
        />
        <TextField
          label="Observații (opțional)"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          fullWidth
          multiline
          rows={2}
          InputProps={{ sx: { borderRadius: 2 } }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 2,
          gap: 2,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          sx={{
            borderRadius: "30px",
            px: 5,
            py: 2,
            color: theme.palette.mode === "light" ? "#444" : undefined,
            borderColor: theme.palette.mode === "light" ? "#999" : undefined,
            "&:hover": {
              backgroundColor:
                theme.palette.mode === "light" ? "#f0f0f0" : undefined,
            },
          }}
        >
          Anulează
        </Button>

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{ borderRadius: "30px", px: 5, py: 2 }}
        >
          {initialData ? "Actualizează" : "Salvează"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSlabModal;
